import React from "react";
import { notificationRepo } from "../../services";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { useMockCustomer } from "./useMockCustomer";
import { Badge, Card, EmptyState, formatDate, useAsync } from "../../components/ui";
import Icon from "../../components/ui/Icon";

export default function CustomerNotifications() {
  const { orgId } = useApp();
  const { tx } = useI18n();
  const { customer } = useMockCustomer(orgId);
  // แจ้งเตือนที่ระบุ customerId เห็นเฉพาะเจ้าของ · ที่ไม่ระบุ = ประกาศถึงลูกค้าทั้งร้าน · ยังไม่ผูกบัญชีลูกค้า = ไม่แสดงอะไร
  const { data: notifications } = useAsync(
    () => (customer ? notificationRepo.all(orgId, (row) => row.audience === "customer" && (!row.customerId || row.customerId === customer.id)) : Promise.resolve([])),
    [orgId, customer],
    []
  );

  if (!notifications?.length) return <EmptyState icon={<Icon name="bell" />} text={tx("ยังไม่มีการแจ้งเตือน", "No notifications")} />;

  return (
    <>
      {notifications.map((item) => (
        <Card key={item.id}>
          <div className="u-between">
            <div className="u-strong u-fs-14">{item.title}</div>
            {!item.read ? <Badge tone="indigo">{tx("ใหม่", "New")}</Badge> : null}
          </div>
          <div className="u-fs-13 u-muted u-mt-8">{item.detail}</div>
          <div className="u-fs-12 u-muted u-mt-8">{formatDate(item.createdAt, true)}</div>
        </Card>
      ))}
    </>
  );
}
